var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcThreeDashesView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-view",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.092,
    height: 16.874,
    viewBox: "0 0 21.092 16.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4070",
    "data-name": "Group 4070"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2457",
    "data-name": "Rectangle 2457",
    width: 3.339,
    height: 3.376,
    transform: "translate(0 13.498)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2458",
    "data-name": "Rectangle 2458",
    width: 15.362,
    height: 3.376,
    transform: "translate(5.73 13.498)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2459",
    "data-name": "Rectangle 2459",
    width: 3.339,
    height: 3.374,
    transform: "translate(0 6.75)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2460",
    "data-name": "Rectangle 2460",
    width: 15.362,
    height: 3.374,
    transform: "translate(5.73 6.75)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2461",
    "data-name": "Rectangle 2461",
    width: 3.339,
    height: 3.374,
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2462",
    "data-name": "Rectangle 2462",
    width: 15.362,
    height: 3.374,
    transform: "translate(5.73)",
    fill: "#f26122"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThreeDashesView);
export default __webpack_public_path__ + "static/media/ic-three-dashes-view.c813886c.svg";
export { ForwardRef as ReactComponent };